import React from 'react';

import './HLine.css';

function HLine() {
  return <div className='HLine' />;
}

export default HLine;
